import {ObjectUtils} from './object-utils';

export class ArrayUtils {

  public static isEmpty<T>(array: T[]): boolean {
    return ObjectUtils.isNullOrUndefined(array) || array.length === 0;
  }

  public static empty(): any [] {
    return [];
  }
}
